/**
 * 任务
 */
import taskApi from '../../api/task.api'

const state = {
    taskList: []
};

const getters = {
};

const mutations = {
    setTaskList(state, data) {
        state.taskList = data;
    }
};

const actions = {
    //获取任务列表
    getTaskList({commit}) {
        return taskApi.getTaskList().then(list => {
            commit('setTaskList', list);
            return list;
        })
    },
    //获取任务项信息
    getTaskItem({state, dispatch}, key) {
        return state.taskList.length ?
            Promise.resolve(state.taskList.find(item => item.key === key)) :
            dispatch('getTaskList').then(() => {
                return state.taskList.find(item => item.key === key)
            });
    },
    //验证任务是否已经完成过
    isFinishTask({}, taskId) {
        return taskApi.isFinishTask(taskId);
    },
    //验证任务条件是否达到
    canFinishTask({}, taskId) {
        return taskApi.canFinishTask(taskId);
    },
    //完成任务
    finishTask({}, taskId) {
        return taskApi.finishTask(taskId);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};


// WEBPACK FOOTER //
// ./app/store/modules/task.js